import ImgCrop from 'antd-img-crop';
import React, { useState, useEffect} from 'react';
import { Upload, Form, Typography} from 'antd';
import "./index.css"

const StoreMultipleUploads = ({label, name, required, message, form, appData}) => {
  const [fileList, setFileList] = useState([]);
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList)
    form.setFieldsValue({...form.getFieldsValue, [name]: newFileList?.length ? newFileList?.map(file=> file?.originFileObj || file?.thumbUrl) : null})
  }
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  }
  useEffect(()=>{
    if(appData && appData?.image?.length)
    {
      let images= appData?.image
      let files=[]
      for(let i=0;i<images?.length; i++)
        files?.push({thumbUrl: images[i]})
      setFileList([...files])
    }
    else
    setFileList([])
  }, [appData])
  return (
    <Form.Item
      name={name}
      label={<Typography.Text strong>{label}</Typography.Text>}
      rules={[
          {
          required,
          message,
          },
      ]}
      >
        <ImgCrop rotationSlider>
          <Upload
            name={name}
            action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
            listType="picture-card"
            fileList={fileList}
            onChange={onChange}
            onPreview={onPreview}
          >
            {fileList.length < 5 && '+ Upload'}
          </Upload>
        </ImgCrop>
    </Form.Item>
  );
};
export {StoreMultipleUploads}